export enum EMapState {
    ALL_CITIES = 'ALL_CITIES',
    CITY = 'CITY',
    ALL_BEACHES = 'ALL_BEACHES',
    BEACH = 'BEACH',
    ALL_SECTIONS = 'ALL_SECTIONS',
    SECTION = 'SECTION',
    REGION = 'REGION',
    ROWS = 'ROWS',
}